import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { Button, Form, FormGroup } from 'reactstrap';
import FormItem from '../../../../common/forms/FormItem';
import { isRequired } from '../../../../../utils/validators';
import FormFooter from '../../../../common/forms/FormFooter';
import BoardingMotiveSelect from '../../../../common/forms/select/MovementReasonSelect';

const ItineraryBoardingMotiveForm = ({
  handleSubmit,
  onCancel,
  isBoarding,
  isLeaving,
  loadingBoardingDraft,
}) => (
  <Form onSubmit={handleSubmit}>
    <FormGroup>
      <FormItem label="Motivo" sm={12} labelSmWidth={0} itemSmWidth={12}>
        <Field
          name="reason"
          component={BoardingMotiveSelect}
          validate={[isRequired]}
          isBoarding={isBoarding}
          isLeaving={isLeaving}
        />
      </FormItem>
    </FormGroup>
    <br />
    <FormFooter saveButtonDisabled={loadingBoardingDraft}>
      <Button
        color="secondary"
        type="button"
        onClick={onCancel}
        disabled={loadingBoardingDraft}
      >
        Cancelar
      </Button>
    </FormFooter>
  </Form>
);

ItineraryBoardingMotiveForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  isBoarding: PropTypes.bool,
  isLeaving: PropTypes.bool,
  loadingBoardingDraft: PropTypes.bool,
};

ItineraryBoardingMotiveForm.defaultProps = {
  isBoarding: null,
  isLeaving: null,
  loadingBoardingDraft: false,
};

export default reduxForm({
  form: 'itineraryBoardingMotiveForm',
})(ItineraryBoardingMotiveForm);
